import React from "react";
import { GraduationCap, Award } from "lucide-react";
import { siteData } from "../mock";

export default function About() {
  return (
    <section className="container-tight py-24">
      <div className="grid lg:grid-cols-5 gap-14 items-center">
        <div className="lg:col-span-2 relative">
          <div className="rounded-[2rem] overflow-hidden aspect-[4/5]">
            <img
              src={siteData.practitioner.photo}
              alt="Jean-Christophe Happillon, coach sportif et fasciathérapeute à Saint-Orens-de-Gameville"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-3">
          <span className="chip mb-4">Votre praticien</span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
            {siteData.practitioner.name}
          </h2>
          <p className="text-[#d97757] mt-2 font-medium">{siteData.practitioner.title}</p>

          <p className="mt-6 text-[#4a4642] text-lg leading-relaxed">{siteData.about.intro}</p>
          <p className="mt-4 text-[#4a4642] leading-relaxed">{siteData.about.bio}</p>

          <div className="mt-8">
            <div className="flex items-center gap-2 mb-4">
              <Award size={18} className="text-[#d97757]" />
              <h3 className="font-semibold text-[#1a1815]">Certifications</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {siteData.about.certifications.map((c, i) => (
                <span key={i} className="chip"><GraduationCap size={12} /> {c}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
